<template>
  <div class="ma-5" id="event-calendar">
    <v-row class="fill-height my-4" justify="center">
      <v-col xl="6" lg="7" md="8" sm="10">
        <v-row>
          <v-col lg="5" md="5" sm="5" cols="12">
            <label class="text-body-2 my-2">Start Date</label>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="all date"
                  class="text-field-border input-event"
                  v-model="startFm"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  solo
                  dense
                  flat
                  readonly
                  placeholder="DD MMM YYYY"
                  hide-details
                  :color="buttonColor"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateStart"
                no-title
                @input="menu1 = false"
                :color="buttonColor"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col lg="5" md="5" sm="5" cols="12">
            <label class="text-body-2 my-2">End Date</label>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="all date"
                  class="text-field-border input-event"
                  v-model="endFm"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  solo
                  dense
                  flat
                  readonly
                  placeholder="DD MMM YYYY"
                  hide-details
                  :color="buttonColor"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateEnd"
                no-title
                @input="menu2 = false"
                :color="buttonColor"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col md="2" lg="2" sm="2" cols="12">
            <v-btn
              :loading="loading"
              :disabled="loading"
              :color="buttonColor"
              height="39"
              class="mt-5 white--text"
              @click="clearDate()"
            >
              Clear
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <template v-for="item in itemEvents">
      <v-row class="mt-2" justify="center" :key="item">
        <v-col class="pa-2" xl="6" lg="7" md="8" sm="10">
          <v-card
            :style="{
              'border-left-color': getColorType(item.type),
              'border-left-width': 'thick',
            }"
            class="day-calendar"
            outlined
          >
            <v-list-item three-line>
              <v-list-item-icon class="mt-5 mr-4 text-center">
                <v-row no-gutters justify="center">
                  <v-col cols="12"
                    ><div class="mt-5">
                      <v-img
                        :src="getIconType(item.type)"
                        max-width="40"
                        max-height="40"
                      ></v-img></div
                  ></v-col>
                </v-row>
                <v-divider vertical class="ml-4 divider-line"></v-divider>
              </v-list-item-icon>
              <v-list-item-content
                @click="showDetail(item)"
                :class="item.type == 'GENERAL' ? 'not-allowed' : 'pointer'"
              >
                <v-list-item-title class="text-subtitle-1">
                  <span>{{ item.title }}</span>
                  <span
                    class="
                      text-caption
                      font-weight-ligh
                      grey--text
                      text--darken-3
                    "
                  >
                    ({{ item.created_at | moment("from", "now") }})</span
                  >
                </v-list-item-title>
                <v-list-item-subtitle class="text-subtitle-2">{{
                  item.body
                }}</v-list-item-subtitle>
                <v-list-item-subtitle
                  class="text-body-2 mt-2"
                  v-if="item.event.startTime != '' && item.event.endTime != ''"
                >
                  <span class="mr-2"><b>start :</b></span>
                  <v-chip
                    small
                    label
                    color="green darken-3"
                    class="px-1 white--text"
                    outlined
                  >
                    {{ item.event.startTime | moment("DD MMM YYYY HH:mm A") }}
                  </v-chip>
                  <span class="mx-2"><b>to</b></span>
                  <v-chip
                    small
                    label
                    color="green darken-3"
                    class="px-1 white--text"
                    outlined
                  >
                    {{
                      item.event.endTime | moment("DD MMM YYYY HH:mm A")
                    }}</v-chip
                  >
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar
                v-if="item.image != '' && item.image !== null"
                size="80"
                color="grey"
                tile
                class="mt-4"
              >
                <v-img :src="item.image"></v-img>
              </v-list-item-avatar>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <v-row justify="center" v-if="itemEvents.length == 0">
      <v-col
        class="pa-2 text-center text-body-1 grey--text text--darken-1"
        xl="6"
        lg="7"
        md="8"
        sm="10"
      >
        No Data Found
      </v-col>
    </v-row>
    <v-row justify="center" v-if="limit * page < countItem">
      <v-col class="pa-2 text-center" xl="6" lg="7" md="8" sm="10">
        <v-btn depressed block @click="seeMore()">See More</v-btn>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import Vue from "vue";
import moment from "moment";
export default {
  data: (vm) => ({
    itemEvents: [],
    dateStart: "",
    dateEnd: "",
    startFm: "",
    endFm: "",
    menu1: false,
    menu2: false,
    loading: false,
    loader: null,
    page: 1,
    limit: 10,
    countItem: 0,
  }),
  computed: {
    buttonColor() {
      return Vue.prototype.$userInfo.companies[0].buttonColor
        ? Vue.prototype.$userInfo.companies[0].buttonColor
        : "primary";
    },
  },
  mounted() {
    this.getEventList();
  },
  watch: {
    dateStart(val) {
      this.page = 1;
      this.startFm = moment(this.dateStart).format("DD MMM YYYY");
      //this.endFm = moment(this.dateStart).format("DD-MMM-YYYY");
      this.getEventList();
    },
    dateEnd(val) {
      this.page = 1;
      this.endFm = moment(this.dateEnd).format("DD MMM YYYY"); //23:59:59
      this.getEventList();
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 500);

      this.loader = null;
    },
  },
  methods: {
    clearDate() {
      this.loader = "loading";
      this.startFm = "";
      this.endFm = "";
      this.page = 1;
      this.getEventList();
    },
    getEventList() {
      let endDateTime = moment(this.endFm)
        .endOf("day")
        .format("DD MMM YYYY HH:mm:ss");
      let start = this.startFm != "" ? moment(this.startFm).format("x") : "";
      let end = this.endFm != "" ? moment(endDateTime).format("x") : "";
      let params = {
        starttime: start,
        endtime: end,
        page: this.page,
        limit: this.limit,
      };
      if (this.page == 1) {
        this.itemEvents = [];
      }

      let url = `${this.$store.state.api}/event/list`; //"https://tula-api-sandbox2.deknerd.com/api/event/list";
      this.$http
        .get(`${url}?${this.$utility.routerQueryStringToUrlParams(params)}`)
        .then((resp) => {
          if (resp.status == 200 && resp.data.status) {
            this.countItem = resp.data.result.count;
            resp.data.result.data.forEach((item) => {
              this.itemEvents.push(item);
            });
          }
        })
        .catch(() => {});
    },
    /*getDayColorCode(date) {
      let day = moment(date).format("ddd");
      let color = "#000000";
      switch (day.toUpperCase()) {
        case "SUN":
          color = "#E53935";
          break;
        case "MON":
          color = "#FFEE58";
          break;
        case "TUE":
          color = "#F06292";
          break;
        case "WED":
          color = "#43A047";
          break;
        case "THU":
          color = "#FB8C00";
          break;
        case "FRI":
          color = "#2196F3";
          break;
        case "SAT":
          color = "#6A1B9A";
          break;
        default:
          break;
      }
      return color;
    },*/
    async showDetail(item) {
      if (item.type == "URL" && item.url != "") {
        window.open("https://" + item.url, "_blank");
      }
      if (
        (item.type == "EXAM" || item.type == "COURSE" || item.type == "LIVE") &&
        item.course
      ) {
        await this.checkCourseLecture(item);
      }
    },
    async checkCourseLecture(item) {
      let courseId = item.course ? item.course._id : "";
      let type = item.type;
      let liveId = item.livestreamv2 ? item.livestreamv2 : "";

      await this.$http
        .get(
          `${this.$store.state.api}/course/section/detail?idcourse=${courseId}`
        )
        .then((resp) => {
          if (resp.status == 200 && resp.data.status) {
            let itemLive = [];
            if (type == "LIVE") {
              console.log(resp.data.result.Live_LivestreamsV2);
              itemLive = resp.data.result.Live_LivestreamsV2.filter(
                (live) =>
                  (live.state == "on_demand" || live.state == "live_now") &&
                  live._id == liveId
              );
              if (itemLive.length == 0) {
                this.$router.push({
                  name: "classroom",
                  params: {
                    id: courseId,
                    tab: "live",
                  },
                });
              } else {
                if (itemLive[0].canWatch) {
                  //let newLive = itemLive[0].newLive ? "?newLive=true" : "";
                  let newLive = "?newLive=true";
                  this.$router.push(`/live/${courseId}-${liveId}${newLive}`);
                }
              }
            } else {
              this.$router.push({
                name: "classroom",
                params: {
                  id: courseId,
                },
              });
            }
          }
        })
        .catch(() => {
          this.checkCourseDetail(courseId);
        });
    },
    checkCourseDetail(courseId) {
      this.$http
        .get(`${this.$store.state.api}/course/detail?id=${courseId}`)
        .then((resp) => {
          this.$router.push({
            name: "course_detail",
            params: {
              id: courseId,
            },
          });
        })
        .catch(() => {
          alert("Sorry, you don't have permission");
        });
    },
    getIconType(type) {
      let name = require("@/assets/icon/events/general.png");
      switch (type.toUpperCase()) {
        case "COURSE":
          name = require("@/assets/icon/events/course.png");
          break;
        case "LIVE":
          name = require("@/assets/icon/events/live.png");
          break;
        case "EXAM":
          name = require("@/assets/icon/events/exam.png");
          break;
        case "URL":
          name = require("@/assets/icon/events/url.png");
          break;
      }
      return name;
    },
    getColorType(type) {
      let color = "#0091EA";
      switch (type.toUpperCase()) {
        case "COURSE":
          color = "#FF9800";
          break;
        case "LIVE":
          color = "#F44336";
          break;
        case "EXAM":
          color = "#4CAF50";
          break;
        case "URL":
          color = "#9C27B0";
          break;
      }
      return color;
    },
    seeMore() {
      this.page++;
      this.getEventList();
    },
  },
};
</script>

<style scoped>
.day-calendar {
  border-left-color: #1976d2a6;
  border-left-width: thick;
}
.text-field-border {
  border: 1px solid;
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  height: 40px;
  color: rgb(77, 77, 77);
}
.pointer {
  cursor: pointer;
}
.not-allowed {
  cursor: not-allowed;
}
.divider-line {
  height: 72px;
}
.title-date {
  padding: 6px 10px;
  color: white;
  background-color: #607d8b;
}
</style>
<style>
#event-calendar
  .text-field-border.input-event.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  min-height: 36px;
}
/* #event-calendar .text-field-border.v-text-field--solo {
  border-radius: 0px;
} */
</style>